export interface IExteriorOrInteriorOrRoomCardProps {
    data: IData | IData[];
    columns?: string; // Optional prop to control the number of columns
}

interface IData {
    [key: string]: string
}

const Card = (props: IData) => {
    const { label, value, columns } = props;

    return (
        <div className={`col-6${columns === '3' ? ' col-md-4' : ''} mb-3`}>
            <div className="font_weight--bold font_size--small_extra">{label}</div>
            <div className="font_size--large text-break">{value}</div>
        </div>
    )
}

export const ExteriorOrInteriorOrRoomCard = (props: IExteriorOrInteriorOrRoomCardProps) => {
    const { data, columns = '3' } = props
    return (
        <div className="row">
            {Array.isArray(data) ? (
                <>
                    {(data).map((data, index) => {
                        const [key, value] = Object.entries(data)[0];
                        return <Card columns={columns} key={`${index}-${key}`} label={key} value={value} />
                    })}
                </>
            ) : (
                <>
                    {Object.entries(data || {}).map(([key, value], index) => {
                        return <Card columns={columns} key={`${index}-${key}`} label={key} value={value} />
                    })}
                </>
            )}

        </div>
    )
}

